import { render, staticRenderFns } from "./QuickInvoiceListSideMenu.vue?vue&type=template&id=2c8573cf&scoped=true"
import script from "./QuickInvoiceListSideMenu.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./QuickInvoiceListSideMenu.vue?vue&type=style&index=0&id=2c8573cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8573cf",
  null
  
)

export default component.exports